exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.width100[data-v-0c39a116] {\n    max-width: 700px;\n}\n", ""]);
